import TechnicalRepresentativeTableContainer from './TechnicalRepresentativeTableContainer';

export default TechnicalRepresentativeTableContainer;